import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';
import { deleteUserEducation } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const DeleteUserEducationForm = () => {
  const profileState = useProfileState();
  const { onResponse, onError, closeDeleteUserEducationModal } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    deleteUserEducation({
      onResponse,
      onError,
      body: {
        authenticityToken,
        deleteUserEducationForm: profileState?.deleteUserEducationForm,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to delete this education?
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              if (profileState?.user?.isAuthenticatedUser) {
                closeDeleteUserEducationModal();
              }
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="destructive"
          >
            Yes. Delete This Education.
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default DeleteUserEducationForm;
